import { useSelector } from "react-redux";
import { getAvailablePaths } from "@icarius-app/selectors";

const useIsPathAvailable = (path) => {
    const availablePaths = useSelector(getAvailablePaths);
    return availablePaths.includes(path);
};

export default useIsPathAvailable;
